import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';

/**
 * Prominent nudge shown throughout the manual browse flow recommending the
 * (more accurate) Instant Estimate. Optionally deep-links with a device prefill.
 */
const InstantEstimateNotice = ({ device = '', className = '' }) => {
  const to = device ? `/sell?device=${encodeURIComponent(device)}` : '/sell';
  return (
    <div
      className={`relative overflow-hidden rounded-2xl border border-emerald-500/40 bg-gradient-to-r from-emerald-600/15 via-emerald-500/10 to-cyan-500/10 p-4 sm:p-5 ${className}`}
      data-testid="instant-estimate-notice"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
            <Zap className="w-5 h-5 text-emerald-400" />
          </div>
          <div>
            <p className="text-white font-semibold text-sm sm:text-base">
              Get a faster, more accurate price with our Instant Estimate
            </p>
            <p className="text-slate-300 text-xs sm:text-sm mt-0.5">
              Our AI-powered Instant Estimate uses live market data for the most accurate offer, we recommend it over browsing categories.
            </p>
          </div>
        </div>
        <Link
          to={to}
          className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-sm whitespace-nowrap transition-colors"
          data-testid="instant-estimate-notice-cta"
        >
          Try Instant Estimate
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

// Browse-by-category prices are all $0 — real offers only come from Instant Estimate.
export const BrowsePriceNotice = ({ device = '', className = '' }) => (
  <div className={`space-y-3 ${className}`} data-testid="browse-price-notice">
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-left">
      <p className="text-amber-700 font-semibold text-sm">Prices here show $0 on purpose</p>
      <p className="text-slate-300 text-xs sm:text-sm mt-0.5">
        Browse-by-category doesn't give real offers. To see what your device is worth, use our Instant Estimate.
      </p>
    </div>
    <InstantEstimateNotice device={device} />
  </div>
);

export default InstantEstimateNotice;
